import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { EnableFatturaPRModalComponent } from './enable-fattura-pr-modal';

export const EnableFatturaPRModalModule: string = ng
    .module('enable-fattura-pr-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('enableFatturaPRModalComponent', EnableFatturaPRModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/enable-fattura-pr-modal/enable-fattura-pr-modal.module.ts